import { DateTime } from 'luxon';
import { DailyReportCardLayout } from 'modules/components/layer05';
import { SaveAccidentModal } from 'modules/components/layer17';
import { DailyReportItem } from 'modules/components/layer19';

import React, { useState } from 'react';


export type ReportAccidentCardProps = {
  id: string;
  incidents: {
    id: string;
    createdOn: DateTime;
    issueDate: DateTime;
    personsInvolved: {
      name: string;
      imgUrl: string;
    }[];
    description: string;
  }[];
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: ReportAccidentCardProps) => {
  const [
    isVisible,
    setIsVisible
  ] = useState(false);

  return (
    <>
      {isVisible && (
        <SaveAccidentModal.FC
          id=''
          isVisible={isVisible}
          handleClose={() => setIsVisible(() => false)}
        />
      )}
      <DailyReportCardLayout.FC
        title='Accidents'
        subTitle='Events that resulted in damage.'
        actionButton={{
          text: 'Add new Accident',
          onClick: () => {
            setIsVisible(() => true);
          }
        }}
      > {
          props.incidents.map((node) => (
            <DailyReportItem.FC
              key={node.id}
              id={node.id}
              details={{
                type: 'ACCIDENT',
                description: node.description,
                involved: node.personsInvolved
              }}
              reportItemType='ACCIDENT'
            />
          ))
        }
      </DailyReportCardLayout.FC>
    </>
  );
};
